import { render, staticRenderFns } from "./PriceNegotiationForm.vue?vue&type=template&id=4846df73&scoped=true&"
import script from "./PriceNegotiationForm.vue?vue&type=script&lang=js&"
export * from "./PriceNegotiationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846df73",
  null
  
)

export default component.exports